import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { donorStatusLabel } from "@/lib/status";

// Managed vehicle lists (categories + donor statuses) — the owner-editable source of
// truth. Cached promises so dropdowns across pages share one fetch; bump() refreshes
// after an edit in Vehicle Setup.
let _cats = null;
let _statuses = null;

export function getVehicleCategories(force = false) {
  if (!_cats || force) _cats = api.get("/vehicle-categories").then((r) => r.data.items || []);
  return _cats;
}
export function getDonorStatuses(force = false) {
  if (!_statuses || force) _statuses = api.get("/donor-statuses").then((r) => r.data.items || []);
  return _statuses;
}
export function refreshVehicleLists() { _cats = null; _statuses = null; }

export function useDonorStatuses() {
  const [items, setItems] = useState([]);
  useEffect(() => { getDonorStatuses().then(setItems).catch(() => setItems([])); }, []);
  return items;
}
export function useVehicleCategories() {
  const [items, setItems] = useState([]);
  useEffect(() => { getVehicleCategories().then(setItems).catch(() => setItems([])); }, []);
  return items;
}

// "Not in any stage" — mirrors OFF_PIPELINE on the server. A truck whose status isn't one of the
// owner's live stages is counted by no pill, so the strip offers this as a real filter instead of
// leaving those trucks unreachable.
export const OFF_PIPELINE = "__off_pipeline__";

// ONE place that turns a stage code into words. The owner's managed NAME wins; the hardcoded
// fallback map only covers codes the list no longer has (retired stages still stamped on old
// trucks), which is why a renamed stage used to show two different names on the same page.
export function useDonorStageLabel() {
  const items = useDonorStatuses();
  return useCallback((code) => {
    if (code === OFF_PIPELINE) return "Not in any stage";
    const hit = items.find((s) => s.code === code);
    return hit?.name || donorStatusLabel(code);
  }, [items]);
}

